import React, {useEffect, useState} from 'react';
import useCodeData from "../../../hooks/useCodeData";
import CommonPagination from "../../table/movable/CommonPagination";
import {DrawerTriger, SearchLabel} from "../drawer/Style";
import {List} from "./List";
import {faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {isMobile} from "../../commonmethod/CommonMethod";
import {
    searchOnchangeHandler,
    subSearchObjectListener,
    subSearchRawValueListener
} from "../../commonmethod/simmsDrawerMethod";
import {useSelector} from "react-redux";

/**
 * data         |  필수  |  obj  | 선택된 값
 * onChange     |  필수  |   f   | 선택된 값을 변경해주는 세터    |
 * entity       |  필수  |  obj  | 드로어에 나와야 하는 코드값  | {name, (옵셔널)parentKey }
 *
 * constraint   | 옵셔널 |  obj  | { required, lessThan, largerThan }
 * auth         | 옵셔널 | bool  | 수정가능 여부, 없으면 수정 불가.
 * placeHolder  | 옵셔널 |   v   | 버튼의 기본 문구. 없으면 '선택'
 * title        | 옵셔널 |   v   | 드로어의 탸이틀
 * uniqueKey    | 옵셔널 |   v   | useCodeData 의 검색조건, 페이징을 분리하기 위한 캐싱 키(중복되지 않도록)
 * recursive    | 옵셔널 | bool  | 목록이 재귀형 데이터 인지 
 * children     | 옵셔널 |  []   | 검색 컴포넌트
 * */



function SimmsDrawerSearch({onChange,  data, title, entity, target, parentKey, constraint, auth, recursive, placeHolder, uniqueKey, children, showLabel, ...rest }) {

    useEffect(() => {
        setLabel(data?.name?? data?.assetName ?? placeHolder?? '선택')
        if(autoClose) {
            closeDrawer()
        }
    },[data])

    const [autoClose, setAutoClose] = useState(true)
    const [label, setLabel] =useState();
    const [slideIn, setSlideIn] =useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const {dataSet, loading, pageInfo, searchConditions, handlePageChange, handleSearch } = useCodeData(entity, uniqueKey );
    const [subSelected, setSubSelected] = useState({});
    const open =useSelector(state => state.opener.drawer[title]||false);

    const closeDrawer=()=>{
        setSlideIn(false)
    }

    const openDrawer =()=>{
        document.body.style.overflow = "hidden";
        setSlideIn(true);
    }

    let codes = [];
    if(!loading && dataSet) {
        if (parentKey) {
            codes = dataSet.content.filter(each => each.id === parentKey);
        } else {
            codes = [{children : dataSet.content}];
        }
    }

    const handledOnChange = (...args) => {
        onChange(...args)
        setSlideIn(false)
    }

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {

            if (child.props.type === 'HIDDEN') {
                // 'HIDDEN' type인 경우 searchConditions의 entityId 값에 hiddenValue의 value로 설정
                searchConditions.entityId = child.props.value;
            }

            const customOnChange = (value) => {if (typeof value === 'object' && value !== null) {
                subSearchObjectListener(setSubSelected, handleSearch, value, searchConditions, { t: child.props.target, uniqueKey: child.props.uniqueKey });
            }else{
                subSearchRawValueListener(setSubSelected,  handleSearch, value,searchConditions, { uniqueKey: child.props.uniqueKey });
            }
            };
            const isTextType = child.props.type === 'TEXT'; // 예시로 uniqueKey를 조건으로 사용
            const hiddenValue = child.props.type === 'HIDDEN';

            return React.cloneElement(child, {
                onChange: customOnChange,
                onKeyDown: customOnChange,
                data: subSelected[child.props.target],
                isTextType: isTextType,
            });
        }

        return child;
    });

    const gridChildren = [];
    const specialChildren = [];

    React.Children.forEach(childrenWithProps, child => {
        if (child.props.isTextType) {
            specialChildren.push(child);
        } else {
            gridChildren.push(child);
        }
    });

    // drawer 열리고 닫힐때 제어
    useEffect(() => {
        if (open && dataSet && data) {
            // input의 value값 구현
            const obj = {
                target : {
                    value : data?.name ?? data?.assetName ?? data?.title ?? ""
                }
            };

            // 이벤트 구조를 임의로 그려준 데이터
            onChangeHandler(obj);
        }
    }, [open, dataSet]);

    const onChangeHandler = (e) => {
        // 하위자식까지 탐색 해서 확장해주는 기능은 recusive에서만 사용
        if(recursive) {
            // 이벤트로 검색될 때거나 텍스트로 들어올 때
            const value = e.target ? e : {target : {value : e}};
            searchOnchangeHandler(dataSet, value, expandedMenus, setExpandedMenus, recursive)
        }
    }

    useEffect(() => {
        if (handleSearch) {
            const searchParams = {
                ...subSelected,
            };
            handleSearch(searchParams);
        }
    }, [subSelected]);

    return (
        <div className={"block mr-2"}>
            {/*선택버튼*/}
            <div className={`flex`}>
                {showLabel && <SearchLabel> {title}</SearchLabel>}
                <DrawerTriger onClick={openDrawer} required={constraint?.required} value={label}>{label}</DrawerTriger>
                <div className={`drawer-background ${slideIn ? 'show' : 'none'}`} onClick={() => closeDrawer()}></div>
            </div>

            {/*드로어*/}
            <div className={`search-drawer-view px-[2rem] py-[1rem] ${isMobile? 'mobile-sub-drawer':''} ${slideIn ? 'slide-in-bottom' : ''}`} style={{width: '450px'}}>
                {/*드로어 헤더*/}
                <div className="flex drawer-title border-bb">
                    <span className={`text-[20px] font-bold`}>{title}</span>
                    <FontAwesomeIcon icon={ faChevronUp }
                                     onClick={closeDrawer}
                                     className="font-thin text-[17px] inline-block ml-auto mt-[8px]" />
                </div>

                {specialChildren &&
                    <div className="mb-[10px] indent-0">
                        {specialChildren}
                    </div>
                }

                {childrenWithProps ? (
                    <div className={`children-mb-3 isDetailOpen grid  grid-cols-2`}>
                        {gridChildren}
                    </div>
                ) : (
                    <div className={'w-full indent-0'}>
                        <input autoComplete="off" id="name" placeholder={`검색하세요.`}
                               onChange={(e) => recursive ? searchOnchangeHandler(dataSet, e, expandedMenus, setExpandedMenus, recursive) : searchOnchangeHandler(dataSet, e, expandedMenus, setExpandedMenus)}
                               className={"outline-1 w-full h-[30px] mb-[10px] border line-height-30 pl-[10px]"}/>
                    </div>
                )}

                <div className={`border overflow-y-auto ${pageInfo && pageInfo.totalPages > 0 ? 'h-[270px]' : 'h-[300px]'} `}>
                    {!loading && dataSet &&
                        <List list={codes[0].children}
                                   onChange={handledOnChange}
                                   // name={''}
                                   data={data}
                                   expandedMenus={expandedMenus}
                                   setExpandedMenus={setExpandedMenus}
                                   required={constraint?.required}
                                   recursive={recursive}/>}
                </div>
                {pageInfo && pageInfo.totalPages > 0 &&
                    <CommonPagination  page={pageInfo} onPageChange={handlePageChange}/>
                }
            </div>

        </div>

    );

}

export default SimmsDrawerSearch;
